/**
 * Single source of truth for countries: enum (codes), display names, and list with flags.
 * Used by CountryDropdown, reducers, and saga to avoid duplication.
 */

import icFlag from "./flags/cotedivoire.jpg";
import snFlag from "./flags/senegal.png";
import tnFlag from "./flags/tunisia.png";
// import frFlag from "./flags/france.png";
// import libFlag from "./flags/libya.png";
import bfFlag from "./flags/burkina-faso.png";
import mlFlag from "./flags/mali.svg.webp";

/** Country codes used across the app (ISO-style). Use these as enum for type safety. */
export enum CountryCode {
  IvoryCoast = "ic",
  Senegal = "sn",
  Tunisia = "tn",
  France = "fr",
  Libya = "lib",
  BurkinaFaso = "bf",
  Mali = "ml",
}

/** Display names by country code */
export const COUNTRY_NAMES: Record<CountryCode, string> = {
  [CountryCode.IvoryCoast]: "Ivory Coast",
  [CountryCode.Senegal]: "Senegal",
  [CountryCode.Tunisia]: "Tunisia",
  [CountryCode.France]: "France",
  [CountryCode.Libya]: "Libya",
  [CountryCode.BurkinaFaso]: "Burkina Faso",
  [CountryCode.Mali]: "Mali",
};

export interface CountryItem {
  code: CountryCode;
  name: string;
  flag: string;
}

/** Ordered list of all countries with flags — use this for dropdowns and redux. */
export const COUNTRIES: CountryItem[] = [
  { code: CountryCode.IvoryCoast, name: COUNTRY_NAMES[CountryCode.IvoryCoast], flag: icFlag },
  { code: CountryCode.Senegal, name: COUNTRY_NAMES[CountryCode.Senegal], flag: snFlag },
  { code: CountryCode.Tunisia, name: COUNTRY_NAMES[CountryCode.Tunisia], flag: tnFlag },
  // { code: CountryCode.France, name: COUNTRY_NAMES[CountryCode.France], flag: frFlag },
  // { code: CountryCode.Libya, name: COUNTRY_NAMES[CountryCode.Libya], flag: libFlag },
  { code: CountryCode.BurkinaFaso, name: COUNTRY_NAMES[CountryCode.BurkinaFaso], flag: bfFlag },
  { code: CountryCode.Mali, name: COUNTRY_NAMES[CountryCode.Mali], flag: mlFlag },
];

const countryByCode = new Map<string, CountryItem>(
  COUNTRIES.map((c) => [c.code, c])
);

/** Get country by code (string or enum). Returns undefined if unknown. */
export function getCountryByCode(code: string): CountryItem | undefined {
  return countryByCode.get(code);
}

/** Default country code when none is set */
export const DEFAULT_COUNTRY_CODE: CountryCode = CountryCode.IvoryCoast;
